module.exports = __webpack_public_path__ + "img/fwa-logo.0a3c22d7.jpg";